module.exports = __webpack_public_path__ + "static/media/icon-download.e38d5f48.svg";